/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import Sessions from 'ui/components/organizations/participants/Sessions.vue';
import Privacy from 'ui/components/organizations/participants/Privacy.vue';

// Mixins
import sessions from 'ui/mixins/organizations/sessions';

/**
 * This component is used to manage the participants across all organization's events.
 *
 * @vue-prop {Object} organization the organization details
 *
 * @category ui.components.organizations
 * @exports PaxManager
 * @component
 */
const __vue_script__ = {
    name: 'PaxManager',

    components: {
        Privacy,
        SearchBar,
        Sessions
    },

    mixins: [sessions],

    props: {
        organization: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            childRefresher: null,
            currentComponent: 'sessions',
            email: null,
            searchTerm: '',
            deletedTs: null
        };
    },

    methods: {
        /**
         * Prompts the user for all sessions deletion.
         */
        promptCancel() {
            const title = this.t('bulk.cancel').toString();
            const text = this.t('bulk.cancel_confirm', [this.email]).toString();
            const okButton = this.$i18n.t('general.confirm').toString();

            this.prompt(title, text, okButton, this.cancel);
        },

        /**
         * Prompts the user for all sessions invalidation.
         */
        promptLogOut() {
            const title = this.$i18n.t('general.confirm').toString();
            const text = this.t('bulk.log_out_confirm', [this.email]).toString();
            const okButton = this.t('bulk.log_out').toString();

            this.prompt(title, text, okButton, this.logOut);
        },

        /**
         * Performs the sessions deletion.
         */
        async cancel() {
            const action = this.$services.userSession.cancelAll.bind(this.$services.userSession);

            await this.performAction(action, 'bulk.cancel');

            this.childRefresher = Date.now();
        },

        /**
         * Performs the user logout from all its sessions
         */
        async logOut() {
            const action = this.$services.userSession.invalidateAll.bind(this.$services.userSession);

            await this.performAction(action, 'bulk.log_out');

            this.childRefresher = Date.now();
        },

        /**
         * Performs the user search against the given search term
         */
        searchUser() {
            this.email = this.searchTerm;
            this.deletedTs = undefined;
        },

        /**
         * Handles the user deleted event emitted by child component
         *
         * @param {Number} deletedTs timestamp of the GDPR delete request
         */
        handleUserDeleted(deletedTs) {
            this.deletedTs = deletedTs;
        },

        /**
         * Shortcut method for i18n
         *
         * @param {String} translationKey the component specific translation key
         * @param {String[]} [values] the optional interpolation values
         */
        t(translationKey, values) {
            return this.$i18n.t(`organization.pax_management.${translationKey}`, values).toString();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pax-manager" },
    [
      _vm.email
        ? _c("div", { staticClass: "actions" }, [
            _c(
              "div",
              { staticClass: "btn log-out", on: { click: _vm.promptLogOut } },
              [_vm._v(_vm._s(_vm.t("bulk.log_out")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn btn-danger",
                on: { click: _vm.promptCancel },
              },
              [_vm._v(_vm._s(_vm.t("bulk.cancel")))]
            ),
          ])
        : _vm._e(),
      _c("validation-observer", {
        attrs: { slim: "slim" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    staticClass: "user-management",
                    attrs: { autocomplete: "off" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.searchUser)
                      },
                    },
                  },
                  [
                    _c("search-bar", {
                      attrs: { rules: "email", "show-no-result": false },
                      model: {
                        value: _vm.searchTerm,
                        callback: function ($$v) {
                          _vm.searchTerm = $$v
                        },
                        expression: "searchTerm",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm.email && _vm.deletedTs
        ? _c("div", { staticClass: "user-deleted" }, [
            _c("h2", [_vm._v(_vm._s(_vm.t("deleted_user.title")))]),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.t("deleted_user.message", [
                    _vm.$utils.time.tsToLongDateFormat(_vm.deletedTs),
                  ])
                )
              ),
            ]),
          ])
        : _vm._e(),
      _vm.email && !_vm.deletedTs
        ? _c("ul", { staticClass: "nav" }, [
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.currentComponent == "sessions" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "has-action",
                    on: {
                      click: function ($event) {
                        _vm.currentComponent = "sessions"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.t("sections.workspaces.title")))]
                ),
              ]
            ),
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.currentComponent == "privacy" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "has-action",
                    on: {
                      click: function ($event) {
                        _vm.currentComponent = "privacy"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.t("sections.privacy.title")))]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _c(
        "keep-alive",
        [
          _vm.email && !_vm.deletedTs
            ? _c(_vm.currentComponent, {
                tag: "component",
                attrs: {
                  organization: _vm.organization,
                  email: _vm.email,
                  refresher: _vm.childRefresher,
                },
                on: { "user:deleted": _vm.handleUserDeleted },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/PaxManager.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__